'use strict';

/**
 *
 * @name: PlaylistConfig
 *
 */

function PlaylistConfig($stateProvider) {

  'ngInject';

  function _resolveModuleControllers($ocLazyLoad) {

    return $ocLazyLoad.load('PlaylistBundle');
  }

  $stateProvider
    .state('main.playlistListing', {
      url: 'playlists',
      controller: 'PlaylistListingController',
      templateProvider: $templateCache => $templateCache.get('playlist-listing.index.html'),
      resolve: {
        moduleControllers: _resolveModuleControllers,
        modules: function($q, apiModulesService) {

          var parentType = 'playlist-listing';
          var deferred = $q.defer();

          apiModulesService
            .getModules(parentType)
            .then(function(result) {

              deferred.resolve(result.data);
            }, function() {

              deferred.reject('module load err');
            });

          return deferred.promise;
        }
      }
    })
    .state('main.playlistSingle', {
      url: 'playlist/:playlistId/:slug',
      params: {
        playlistId: {
          value: null
        },
        slug: {
          value: null,
          squash: true
        }
      },
      controller: 'PlaylistSingleController',
      templateProvider: $templateCache => $templateCache.get('playlist-single.index.html'),
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    });
}

export default PlaylistConfig;



// WEBPACK FOOTER //
// ./app/pages/playlist/playlist.config.js